

import { Box, Checkbox, IconButton, ImageList, ImageListItem, Pagination, TableRow, Tooltip, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import ReportingBig from '../../../default/HowIsEventGoing/reportingBig';
import { PaginationItemStyle } from '../../../default/HowIsEventGoing/styled';
import { useDropzone } from 'react-dropzone';
import { IReportingImage } from '../types';
import { CloudUpload, Remove } from '@mui/icons-material';

const itemData = [
    {
        width: 432,
        height: 231,
        rows: 18
    },
    {
        width: 438,
        height: 315,
        rows: 24
    },
    {
        width: 409,
        height: 654,
        rows: 47
    },
    {
        width: 432,
        height: 403,
        rows: 29
    },
    {
        width: 438,
        height: 320,
        rows: 23
    },

    {
        width: 432,
        height: 654,
        rows: 47
    },
    {
        width: 438,
        height: 403,
        rows: 30
    },
    {
        width: 409,
        height: 315,
        rows: 24
    },
    {
        width: 409,
        height: 320,
        rows: 23
    },
    {
        width: 438,
        height: 231,
        rows: 18
    }
];

const ReportingImagesAdmin = () => {

    const myRef = useRef<HTMLDivElement>(null)

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { SearchReportingImage, DeleteReportingImage, CreateReportingImage } = useActions();
    const { reportingImages, count } = useTypedSelector((store) => store.reportingImage);

    useEffect(() => {
        document.title = `Фото звітів`;
        getData();
    }, [page]);

    const getData = async () => {
        try {
            await SearchReportingImage(page, rowsPerPage);
        } catch (ex) {
        }
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (files) => {
            if (!files || files.length === 0) return;

            // setImagesLoading(files.length)
            // let tmp = formik.values.images.slice();
            files.forEach(element => {
                let reader = new FileReader();

                reader.readAsDataURL(element);
                reader.onload = async () => {
                    if (reader.result != null) {
                        let res = await CreateReportingImage(reader.result as string) as unknown as IReportingImage;
                        // tmp.push(res);
                        await getData()
                    }
                };
            });
            // setFieldValue("images", tmp)
            // setImagesLoading(0)
        }
    });

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: "30px" }}>
                <Typography variant="h1" color="inherit">Картинки звітів</Typography>
                {/* <Create afterCreate={() => { getData() }} isTextButton={false} /> */}
            </Box>
            <Box
                sx={{
                    height: "150px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    border: "1px solid #F45626",
                    display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
                }}
            >
                <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <CloudUpload />
                        <Typography variant="subtitle1" color="inherit" align="center">
                            Перемістити фото або натисність щоб здійснити пошук для завантаження
                        </Typography>
                    </Box>
                </div>
            </Box>
            <Box ref={myRef} sx={{ mt: "35px" }} >
                <ImageList
                    variant="quilted"
                    cols={3}
                    rowHeight={10}
                    sx={{ overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <>
                            <ImageListItem key={`reporting_image_${index}`} rows={itemData[index].rows || 1} sx={{ position: "relative", mr: "10px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    // src={itemData[index].img}
                                    style={{ width: `${itemData[index].width}px`, height: `${itemData[index].height}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                                <Tooltip
                                    title={"Видалити фото"}
                                >
                                    <IconButton color="primary"
                                        sx={{
                                            position: "absolute",
                                            right: "5px",
                                            top: "5px",
                                            border: 2,
                                            borderRadius: "12px",
                                            "&& .MuiTouchRipple-child": {
                                                border: 0,
                                                borderRadius: "10px",
                                            },
                                        }}
                                        onClick={async () => {
                                            await DeleteReportingImage(item.id);
                                            await getData()
                                        }}
                                    >
                                        <Remove />
                                    </IconButton>
                                </Tooltip>
                            </ImageListItem>
                            {index === 4 && <ImageListItem key={`reporting_image_m_${index}`} cols={3} />}
                        </>
                    ))}
                </ImageList>
            </Box>
            {count !== 0 && <Box sx={{ display: "flex", justifyContent: "center", mt: "35px", mb: "120px" }}>
                <Pagination count={Math.ceil(count / rowsPerPage)} page={page} shape="rounded" size="large"
                    onChange={(event: any, value: number) => {
                        handleChangePage(event, value);
                        if (myRef.current) {
                            myRef.current.scrollIntoView({ behavior: "smooth" });
                        }
                    }}
                    renderItem={(item) => <PaginationItemStyle {...item} />} />
            </Box>}
        </>
    );
}

export default ReportingImagesAdmin